import classNames from "classnames"

import "./Label.scss"

type LabelProps = {
  text: string
  htmlFor?: string
  className?: string
}

function Label(props: LabelProps) {
  return (
    <label
      className={classNames("Label", props.className)}
      htmlFor={props.htmlFor}
    >
      {props.text}
    </label>
  )
}

export default Label
